import {AdditionalPhoneNumbersAllowed} from '@/app/auth/constants/AllowedPhoneNumbers';

import {ONLY_DIGITS_REGEX} from './constants';

export function isSpecialNumberAllowed(finalNumber: string): boolean {
  return AdditionalPhoneNumbersAllowed?.some(number => number === finalNumber);
}

export function formatPhoneNumber(
  rawInput: string | undefined | null,
  countryDialCode: string,
): string {
  if (!rawInput) {
    return `+${countryDialCode}`;
  }

  // Check the leading "+" on the raw input, before stripping non-digit
  // characters — ONLY_DIGITS_REGEX removes the "+" too, so a full
  // international number (e.g. pasted as "+16025413264") already carries its
  // own dial code and shouldn't have the selected country's dial code
  // prepended on top of it (that would double it up, e.g. "+116025413264").
  const hasDialCode = rawInput.trim().startsWith('+');
  const cleanInput = rawInput.replace(ONLY_DIGITS_REGEX, '');

  return hasDialCode ? `+${cleanInput}` : `+${countryDialCode}${cleanInput}`;
}
